/* eslint-disable */
import BoxReveal from "../../magicui/BoxReveal";
import { DownloadAppElearning_v2 } from "../../../pages/home/sections";
import ExternalLink from '../../ExternalLink';
// @mui
import { m } from 'framer-motion';
import { useState } from 'react';
import {
  Box,
  Stack,
  Divider,
  Container,
  useMediaQuery,
  Typography,
  IconButton,
  Dialog,
  Link,
  Grid
} from '@mui/material';
// components
import Iconify from '../../../components/iconify';
import { MotionViewport, varFade } from '../../../components/animate';
// import memberImage from '../../../assets/images/home/Download/member.png';
// ----------------------------------------------------------------------
export function BoxRevealDemo() {
  const isMobile = useMediaQuery('(max-width:700px)');

  const [funModeOpen, setFunModeOpen] = useState(false);

  const handleFunOpen = () => {
    setFunModeOpen(true);
  };

  const handleFunClose = () => {
    setFunModeOpen(false);
  };
  return (
    <div className="h-full w-full overflow-hidden">
     
      <Box
        sx={{
          backgroundColor: '#F4F4F4',
          p: { xs: 2, sm: 10 },
        }}
      >
        <Container
          component={MotionViewport}
          sx={{
            py: 5,
            px: { xs: 2, md: 10 },
            backgroundColor: '#FFFFFF',
            boxShadow: 5,
            borderRadius: { xs: '20px', sm: '50px', md: '100px' },
          }}
        >
          <m.div variants={varFade().inUp}>
           
       <BoxReveal boxColor={"rgb(31, 169, 255)"} duration={0.5}>
                         <Stack
              sx={{
                textAlign: { xs: 'center', md: 'center' },
                my: 2,
              }}
            >
              <Typography
                sx={{
                  fontSize: { lg: '64px', md: '48px', sm: '36px', xs: '28px' },
                  fontWeight: 900,
                  maxwidth: 400,
                  lineHeight: 1,
                }}
              >
                {' '}
                Want to build a<br /> fence{' '}
                <span
                  style={{
                    color: '#1FA9FF',
                  }}
                >
                  right now
                </span>
                ?
              </Typography>
            </Stack>

      </BoxReveal>
            {isMobile ? (
              <BoxReveal boxColor={"rgb(31, 169, 255)"} duration={0.5}>
               <div className="flex flex-col justify-center items-center">
                <AppStoreButton
                  className="w-4/5"
                />
                <GoogleStoreButton
                  className="w-4/5"
                />
              </div>
              </BoxReveal>
             
            ) : (
              <Box sx={{ pr: { md: 8, sm: 0 }, pl: { md: 8, sm: 0 } }}>
               
                <BoxReveal boxColor={"rgb(31, 169, 255)"} duration={0.5}>
                <Stack
                  alignItems="center"
                  sx={{
                    py: 5,
                    borderRadius: 2,
                    px: { xs: 3, md: 5 },
                    border: (theme) => `solid 1px ${theme.palette.divider}`,
                  }}
                >
                  <Typography variant="h5" textAlign="center" mb={2} color="#212B36">
                    Scan QR code to install on your device
                  </Typography>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 5, md: 1 }}>
                    <Stack direction="column" alignItems="center">
                      <Box
                        component="span"
                        className="svg-color"
                        sx={{
                          display: 'inline-block',
                          backgroundColor: '#212B36',
                          backgroundImage: `url(/assets/icons/ic_qrcode.svg)`,
                          backgroundSize: 'cover',
                          width: 120,
                          height: 120,
                          color: '#212B36',
                          border: 10,
                          borderStyle: 'solid',
                          borderRadius: '20px',
                        }}
                      />
                      <Typography variant="h5" textAlign="center" my={1} color="#212B36">
                        Apple Devices
                      </Typography>
                      <AppStoreButton />
                    </Stack>

                    <Divider
                      orientation="vertical"
                      sx={{ height: '100%', borderStyle: 'dashed' }}
                    />

                    <Stack direction="column" alignItems="center">
                      <Box
                        component="span"
                        className="svg-color"
                        sx={{
                          display: 'inline-block',
                          backgroundColor: '#212B36',
                          backgroundImage: `url(/assets/icons/ic_google_qr.svg)`,
                          backgroundSize: 'cover',
                          width: 120,
                          height: 120,
                          color: '#212B36',
                          border: 10,
                          borderStyle: 'solid',
                          borderRadius: '20px',
                        }}
                      />
                      <Typography variant="h5" textAlign="center" my={1} color="#212B36">
                        Android Devices
                      </Typography>
                      <GoogleStoreButton />
                    </Stack>
                  </Stack>
                </Stack>
              </BoxReveal>
              </Box>
            )}

            
            <BoxReveal boxColor={"rgb(31, 169, 255)"} duration={0.5}>
            <Stack
              sx={{
                mt: { xs: 2, md: 5 },
                mb: 3,
                textAlign: 'center',
                fontFamily: 'Public Sans',
              }}
            >
              <Typography variant="h4">No account yet? No problem!</Typography>
              <Typography variant="h4">
                Download the app and try&nbsp;
                <Link
                  style={{
                    color: '#1FA9FF',
                    cursor: 'pointer',
                  }}
                  onClick={handleFunOpen}
                >
                  Fun Mode!
                </Link>
              </Typography>
            </Stack>
            </BoxReveal>
          </m.div>
        </Container>
      </Box>
      {/* <Box>
        <Container component={MotionViewport} maxWidth="sm">
          <m.div variants={varFade().inUp}>
            <Stack
              sx={{
                display: 'flex',
                justifyContent: 'center',
                px: 10,
                py: 5,
              }}
            >
              <img src={memberImage} alt="marketing market" />
            </Stack>
          </m.div>
        </Container>
      </Box> */}
      <Dialog open={funModeOpen} maxWidth="md" fullWidth onClose={handleFunClose}>
        <Stack sx={{ px: { lg: 4, xs: 1, md: 2 }, pt: 2, pb: 4 }}>
          <Grid item sx={{ alignSelf: { xs: 'end', md: 'end' } }}>
            <IconButton color="inherit" edge="start" onClick={handleFunClose}>
              <Iconify icon="carbon:close-filled"  />
            </IconButton>
          </Grid>

          <iframe
            src="https://realityfencefunmode.lpages.co/realityfence-fun-modde/"
            width="100%"
            height="790px"
            title="Fun Mode"
          />
        </Stack>
      </Dialog>
    </div>
  );
}
// ----------------------------------------------------------------------

export function AppStoreButton({ className = '', compact = false, style = {}, ...other }) {
  return (
    <div className={className} style={style} {...other}>
      <ExternalLink
        href="https://apps.apple.com/us/app/realityfence/id6453638654"
        className={
          compact
            ? 'm-0 inline-flex items-center gap-1.5 rounded-lg border border-black/20 px-2.5 py-1.5 text-white'
            : 'inline-flex items-center gap-2 px-3 py-1.5 m-2 text-white border border-black/20 rounded-lg'
        }
        style={{
          background: 'linear-gradient(180deg, #424242 0%, #000000 100%)',
          textDecoration: 'none',
        }}
      >
        <Iconify icon="ri:apple-fill" width={compact ? 22 : 28} />
        <div className="flex flex-col items-start">
          <span className={compact ? 'text-[10px] opacity-70' : 'text-xs opacity-70'}>
            Download on the
          </span>
          <span className={compact ? '-mt-1 text-sm font-semibold' : 'text-lg font-semibold -mt-1'}>
            Apple Store
          </span>
        </div>
      </ExternalLink>
    </div>
  );
}

export function GoogleStoreButton({ className = '', compact = false, style = {}, ...other }) {
  return (
    <div className={className} style={style} {...other}>
      <ExternalLink
        href="https://play.google.com/store/apps/details?id=com.realityfence.ar&hl=en_US&gl=US"
        className={
          compact
            ? 'm-0 inline-flex items-center gap-1.5 rounded-lg border border-black/20 px-2.5 py-1.5 text-white'
            : 'inline-flex items-center gap-2 px-3 py-1.5 m-2 text-white border border-black/20 rounded-lg'
        }
        style={{
          background: 'linear-gradient(180deg, #424242 0%, #000000 100%)',
          textDecoration: 'none',
        }}
      >
        <Iconify icon="logos:google-play-icon" width={compact ? 22 : 28} />
        <div className="flex flex-col items-start">
          <span className={compact ? 'text-[10px] opacity-70' : 'text-xs opacity-70'}>
            GET IT ON
          </span>
          <span className={compact ? '-mt-1 text-sm font-semibold' : 'text-lg font-semibold -mt-1'}>
            Google Play
          </span>
        </div>
      </ExternalLink>
    </div>
  );
}
